import React from 'react';
import ReactDOM from 'react-dom/client';
import UserContext from "./UserContext";

import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css';
import 'notyf/notyf.min.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserContext.Provider value={{}}>
      <App />
    </UserContext.Provider>
  </React.StrictMode>
);